export const listProperties = [
  {
    title: 'Apartamento',
    listItems: [
      {
        item: 'Apartamento',
        code: 3
      },
      {
        item: 'Cobertura',
        code: 3
      },
      {
        item: 'Duplex',
        code: 3
      },
      {
        item: 'Loft',
        code: 3
      },
      {
        item: 'Penthouse',
        code: 3
      },
      {
        item: 'Studio',
        code: 3
      },
      {
        item: 'Triplex',
        code: 3
      }
    ]
  },
  {
    title: 'Casa',
    listItems: [
      {
        item: 'Casa',
        code: 2
      },
      {
        item: 'Casa de vila',
        code: 26
      },
      {
        item: 'Casa térrea',
        code: 27
      },
      {
        item: 'Condomínio',
        code: 29
      },
      {
        item: 'Sobrado',
        code: 33
      },
      // {
      //   item: 'Villagio',
      //   code: 33
      // }
    ]
  },
  {
    title: 'Flat',
    listItems: [
      {
        item: 'Flat',
        code: 17
      }
    ]
  },
  {
    title: 'Galpão',
    listItems: [
      {
        item: 'Barracão',
        code: 36
      },
      {
        item: 'Galpão',
        code: 8
      }
    ]
  },
  {
    title: 'Hotel',
    listItems: [
      {
        item: 'Hotel',
        code: 7
      }
    ]
  },
  {
    title: 'Lajes corporativas',
    listItems: [
      {
        item: 'Lajes corporativas',
        code: 19
      }
    ]
  },
  {
    title: 'Loteamento',
    listItems: [
      {
        item: 'Loteamento',
        code: 5
      }
    ]
  },
  {
    title: 'Mall',
    listItems: [
      {
        item: 'Loja',
        code: 38
      },
      {
        item: 'Mall',
        code: 38
      }
    ]
  },
  {
    title: 'Rural',
    listItems: [
      {
        item: 'Chácara',
        code: 40
      },
      {
        item: 'Fazenda',
        code: 41
      },
      {
        item: 'Rural',
        code: 41
      },
      {
        item: 'Sítio',
        code: 42
      }
    ]
  },
  {
    title: 'Salão',
    listItems: [
      {
        item: 'Salão comercial',
        code: 44
      },
      {
        item: 'Prédio inteiro',
        code: 39
      },
      {
        item: 'Salas',
        code: 4
      }
    ]
  },
  {
    title: 'Terreno',
    listItems: [
      // {
      //   item: 'Área de terra'
      // },
      {
        item: 'Terreno',
        code: 23
      }
    ]
  },
  {
    title: 'Vaga',
    listItems: [
      {
        item: 'Vaga',
        code: 100 // not found
      }
    ]
  },
];

export const listStepperVertical = [
  {
    title: 'Captação',
    listStepper: [
      {
      title: 'Localização',
      icon: 'i_exclamation',
      active: false
      },
      {
        title: 'Tipo de unidade',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'Venda e locação',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'Mais informações',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'Proprietários',
        icon: 'i_exclamation',
        active: false
      }
    ]
  },
  {
    title: 'Caracteristicas',
    listStepper: [
      {
      title: 'Detalhes do imóvel',
      icon: 'i_exclamation',
      active: false
      },
      {
        title: 'Detalhes do condomínio',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'Detalhes adicionais',
        icon: 'i_exclamation',
        active: false
      }
    ]
  },
  {
    title: 'Descrição',
    listStepper: [
      {
        title: 'Descrições para o portal',
        icon: 'i_exclamation',
        active: false
      }
    ]
  },
  {
    title: 'Mídias',
    listStepper: [
      {
        title: 'Fotos',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'outras mídias',
        icon: 'i_exclamation',
        active: false
      },
      {
        title: 'Anexos',
        icon: 'i_exclamation',
        active: false
      }
    ]
  },
  {
    title: 'Profissionais',
    listStepper: [
      {
        title: 'Detalhes para o portal',
        icon: 'i_exclamation',
        active: false
      }
    ]
  },
  {
    title: 'Outras informações',
    listStepper: [
      {
        title: 'Detalhes do imóvel',
        icon: 'i_exclamation',
        active: false
        },
        {
          title: 'Detalhes do condomínio',
          icon: 'i_exclamation',
          active: false
        },
        {
          title: 'Detalhes adicionais',
          icon: 'i_exclamation',
          active: false
        }
    ]
  }
];

export const listStepperHorizontal = [
  {
    icon: 'i_finished.svg',
    iconLast: 'i_finished_last.svg',
    description: 'Básico',
    completed: false
  },
  {
    icon: 'i_finished.svg',
    iconLast: 'i_finished_last.svg',
    description: 'Moderado',
    completed: false
  },
  {
    icon: 'i_intermediate.svg',
    iconLast: 'i_intermediate_last.svg',
    description: 'Intermediário',
    completed: false
  },
  {
    icon: 'i_advanced.svg',
    iconLast: 'i_advanced_last.svg',
    description: 'Avançado',
    completed: false,
  },
  {
    icon: 'i_champion.svg',
    iconLast: 'i_champion_last.svg',
    description: 'Campeão',
    completed: false
  }
];

export const listTabs = [
  {
    id: 1,
    title: 'Captação',
    active: false
  },
  {
    id: 1,
    title: 'Caracteristicas',
    active: false
  },
  {
    id: 1,
    title: 'Descrição',
    active: false
  },
  {
    id: 1,
    title: 'Mídias',
    active: false
  },
  {
    id: 1,
    title: 'Profissionais',
    active: false
  },
  {
    id: 1,
    title: 'Outras informações',
    active: false
  }
];


export const propertiesHeader = [
  // {
  //   id: 1,
  //   nameClass: 'contador',
  //   data: '',
  // },
  {
    id: 2,
    nameClass: 'name',
    data: 'Cód/Produto',
  },
  {
    id: 3,
    nameClass: 'product',
    data: 'Mercado',
  },
  {
    id: 4,
    nameClass: 'address',
    data: 'Endereço',
  },
  {
    id: 5,
    nameClass: 'stage',
    data: 'Tipo',
  },
  {
    id: 6,
    nameClass: 'temp',
    data: 'Torre',
  },
  {
    id: 7,
    nameClass: 'unit',
    data: 'Unidade',
  },
  {
    id: 8,
    nameClass: 'desc',
    data: 'Características',
  },
  {
    id: 9,
    nameClass: 'sales',
    data: 'Venda',
  },
  {
    id: 10,
    nameClass: 'rent',
    data: 'Aluguel',
  },
  // {
  //   id: 11,
  //   nameClass: 'indicator',
  //   data: 'Indicadores',
  // },
  // {
  //   id: 12,
  //   nameClass: 'action',
  //   data: '',
  // }
];


export const mockTableProduct = [
  {
    porcentagem: 85,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 15,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 45,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 80,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 15,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 45,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 80,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  },
  {
    porcentagem: 100,
    codeProduct: '890-IM16391',
    properties: 'Penha Plano Manoel Leiroz de Azevedo',
    mercado: 1,
    imageUrl: 'https://www.incorposul.com.br/wp-content/uploads/2019/08/cropped-como-comprar-um-apartamento-1-1024x576.jpg',
    tipo: 'Apartamento duplex',
    torre: 'Torre A',
    unidade: '73',
    caracteristicas: {
      tamanho: 134,
      dormitorios: 3,
      banheiro: 3,
      camas: 3
    },
    venda: 1300.000,
    aluguel: 50.000,
    condIPTU: '2.345',
    endereco: {
      street: 'Professor Luiz Ignácio Anhaia Mello',
      number: 627,
      city: 'Jardim América',
      neighborhood: 'Vila Bela da Santíssima Trindade',
      state: 'SP'
    },
    atualizado: '13/11/19 12:30',
    usuario: 'Wollner',
    indicadores: {
      predio: 1,
      estrela: true,
      pessoas: true,
      diamante: true,
      iconeEstranho: true,
      calendario: true,
      dinheiro: true
    }
  }
];

// Remove Characters
export const removeCaracter = (event) => {
  event.target.value = event.target.value.replace(/[^0-9\.]+/g, '');
};
